import React, {Fragment, useState} from 'react';
import {
    getBackgroundImg,
    getPublicImagePath,
    getUploadedImagePath, MarkupRender,
    Modal,
    useAppState
} from '@nutastic/nutastic-react-app';
import Fade from 'react-reveal/Fade';
import Footer from "../Footer";
import StoryModal from "../StoryModal";
import {isDarkColor} from "is-dark-color/dist/isDarkColor";
import {message} from "antd";
import classnames from "classnames";

const defaultSiteColor = '#000000';

const HomePage = () => {
    const { pages: {homePage} } = useAppState();
    const { headerConfig, welcomeSectionConfig, highlights } = homePage;
    const { headerLayout, headerTitle, headerText, headerImage, headerPosition  } = headerConfig;
    const {
        hideMission,
        welcomeText,
        buttonOneIsEnabled,
        buttonTwoIsEnabled,
        buttonThreeIsEnabled,
        button1Text,
        button1Url,
        button1Type,
        button2Text,
        button2Url,
        button2Type,
        button3Text,
        button3Url,
        button3Type,
    } = welcomeSectionConfig;
    const [modalContent, setModalContent] = useState(null);
    const componentClass = 'home-page';

    return <main className="home-page">
        <section className={`${componentClass}__header`}>
            <div className="bannerImg animated fadeIn delay-1s" style={getBackgroundImg(getUploadedImagePath(headerImage))} />
            { headerLayout === 'label' && <img src={getPublicImagePath('home--banner-text.png')} className={`${componentClass}__welcomeSign`} alt="We Are Up To Serve | Unmask Purpose" /> }
            { headerLayout === 'message' && <div className="overlay" /> }
            { headerLayout === 'message' && <div className={`container h-100 ${ headerPosition === 'bottom' && 'header-bottom-position'}`}>
                <h1 className={`${componentClass}__title-header`}>{ headerTitle }</h1>
                <p className={`${componentClass}__subtitle animated fadeInUp delay-1s`}>{ headerText }</p>
            </div> }
        </section>

        <section className="aboutSection">
            <Fade>
                <div className="container">
                    { hideMission !== 'true' && <div className={`${componentClass}__missionVision`}>
                        <h1 className="theMission">The Mission<i>Freedom</i></h1>
                        <h1 className="theVision">The Vision<i>Mask Off</i></h1>
                    </div> }
                    <p className="aboutSection__blurb">{ welcomeText }</p>
                    <div className="aboutSection__buttons">
                        { buttonOneIsEnabled === 'true' && <a href={ button1Url } target={ button1Type === 'true' ? '_blank' : '_self'} className={`btn btn-outline-white`}>{ button1Text }</a> }
                        { buttonTwoIsEnabled === 'true' && <a href={ button2Url } target={ button2Type === 'true' ? '_blank' : '_self'} className={`btn btn-white`}>{ button2Text }</a> }
                        { buttonThreeIsEnabled === 'true' && <a href={ button3Url } target={ button3Type === 'true' ? '_blank' : '_self'} className={`btn btn-outline-white`}>{ button3Text }</a> }
                    </div>
                </div>
            </Fade>
        </section>

        {
            (highlights || []).map((highlight, index) => {
                const {
                    title,
                    details,
                    boxColor = "#121212",
                    layoutType,
                    image,
                    buttonType,
                    buttonText,
                    buttonUrl,
                    overrideBoxColor
                } = highlight;
                const highlightClassName = 'storySection';
                const highlightClasses = classnames(highlightClassName, {
                    [`${highlightClassName}--flipped`]: layoutType === 'right'
                });
                const colorToUse = overrideBoxColor === 'true' ? boxColor : defaultSiteColor;
                const highlightStyles = {
                    color: isDarkColor(colorToUse) ? '#ffffff' : '#000000',
                    backgroundColor: colorToUse
                };
                const buttonClasses = isDarkColor(colorToUse) ? 'btn btn-outline-white' : 'btn btn-outline-black';

                return <section className={highlightClasses} key={index}>
                    <Fade left={layoutType === 'left'} right={layoutType === 'right'}>
                        <div className="storySection__image" style={getBackgroundImg(getUploadedImagePath(image))} />
                    </Fade>
                    <Fade delay={250}>
                        <div className={`${highlightClassName}__details`} style={highlightStyles}>
                            <h1 className="isCursive">{ title }</h1>
                            <div className="icon-divider">
                                <i className="ion-ios-infinite" />
                            </div>
                            <p>{ details }</p>
                            { buttonType === 'url' && <a className={buttonClasses} href={buttonUrl} target="_blank">{ buttonText }</a> }
                            { buttonType === 'modal' && <button className={buttonClasses} onClick={() => setModalContent(highlight)}>{ buttonText }</button> }
                        </div>
                    </Fade>
                </section>
            })
        }

        <Footer />

        <Modal show={!!modalContent} onClose={() => setModalContent(null)} title={modalContent ? modalContent?.modalTitle : ''}>
            <MarkupRender className='story-content' tagName='div' content={modalContent?.modalText} />
        </Modal>
    </main>;
};

export default HomePage;
